import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { SiteMarquee } from "@/components/site/Marquee";
import { Activities } from "@/components/site/Activities";
import { Spectacles } from "@/components/site/Spectacles";
import { Concerts } from "@/components/site/Concerts";
import { About } from "@/components/site/About";
import { Agenda } from "@/components/site/Agenda";
import { Pros } from "@/components/site/Pros";
import { Coaching } from "@/components/site/Coaching";
import { MasterclassSouvenir } from "@/components/site/MasterclassSouvenir";
import { SummerStageSouvenir } from "@/components/site/SummerStageSouvenir";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

const Home = () => (
  <div className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A] font-sans">
    <Header />
    <main>
      <Hero />
      <SiteMarquee />
      <Activities />
      <Pros />
      <Coaching />
      <Spectacles />
      <Concerts />
      <Agenda />
      <MasterclassSouvenir />
      <SummerStageSouvenir />
      <About />
      <Gallery />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
    <Toaster position="top-right" richColors />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
